import * as React from "react";
import "./Label.css";

interface IPropsLabel {
    children: React.ReactNode,
    optional?: boolean;
    optionalShort?: boolean;
}

export const Label: React.SFC<IPropsLabel> = ({ children, optional, optionalShort }) => {
    return (
        <div className="form-group__label-wrapper">
            <label className="form-group__label">
                {children}
                {optional &&
                    <span className="form-group__label-optional">
                        {
                            optionalShort ? "Opcjonalne" : "Opc."
                        }
                    </span>
                }
            </label>
        </div>

    );
};


// WEBPACK FOOTER //
// ./src/controls/Form/Label.tsx